"use client";
import { useAuiState } from "@assistant-ui/store";
export const useMessagePartImage = () => {
    const image = useAuiState(({ part }) => {
        if (part.type !== "image")
            throw new Error("MessagePartImage can only be used inside image message parts.");
        return part;
    });
    return image;
};
//# sourceMappingURL=useMessagePartImage.js.map